export default class AddToAccountController {

	static get $inject(){
		return [
			'$scope', '$state',
			'ApiRemoteService',
			'LanguageService',
			'gettext',
		];
	}

	constructor($scope, $state,
	            ApiRemoteService, LanguageService, gettext,){

		this.$scope = $scope;
		this._$state = $state;
		this._ApiRemoteService = ApiRemoteService;
		this.LanguageService = LanguageService;

		this.MESSAGES_TEXT = [gettext('invalid'), gettext('Panel already exists')];
		this.alerts = [
			//{ type: 'danger', msg: 'Oh snap! Change a few things up and try submitting again.' },
			//{ type: 'success', msg: 'Well done! You successfully read this important alert message.' }
		];

		this.item = {control_panel: {}}
	}

	// --- VM Helpers -----------------

	submit(){
		this.isSubmitting = true;
		this.resetAlerts();
		this._ApiRemoteService.addToAccount(this.item)
			.then((r)=>{
				this._$state.go('main.panel.control', {id: r.data.panel_user});
			})
			.catch((e)=>{
				this.$scope.modelState = e.data;
				if (e.data.message) {
					this.addAlert(e.data.message);
				}
			})
			.finally(()=>{
				this.isSubmitting = false;
			})
	};

	closeAlert(index){
		this.alerts.splice(index, 1);
	};

	addAlert(msg){
		this.alerts.push({ type: 'danger', msg: msg });
	};

	resetAlerts(){
		this.alerts = [];
	}

	get logoImage(){
		return logoImage;
	}

    getTranslatableText(text) {

        return this.LanguageService.getTranslatableText(text)

    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/addToAccount/controller.js
 **/